export const DEFAULT_MODULES_IN_THE_API = ['login', 'profile', 'portal']

export const AVAILABLE_MODULES_IN_THE_API = [
  'attendance',
  'alert',
  'admin',
  'activity',
  'archive',
  'dashboard',
  'document',
  'geo',
  'integrated_profile',
  'integrator',
  'messenger',
  'object',
  'regulation',
  'schedule',
  'service',
  'social_manager',
  'survey',
  'carehub',
]
